import { avatarBackground } from '../../utils/user';

type AvatarProps = {
  user: any;
  size?: number;
};

export default function Avatar({ user, size = 44 }: AvatarProps) {
  if (user?.avatar) {
    return (
      <img
        className="avatar"
        style={{ width: size, height: size }}
        src={user.avatar}
        alt=""
      />
    );
  }

  return (
    <div
      className="avatar initials"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.38),
        background: avatarBackground(user),
      }}
    >
      {(user?.username || 'D')[0].toUpperCase()}
    </div>
  );
}
